import { render } from "./newCommentForm.vue?vue&type=template&id=9a140c56&scoped=true&ts=true"
import script from "./newCommentForm.vue?vue&type=script&lang=ts"
export * from "./newCommentForm.vue?vue&type=script&lang=ts"

import "./newCommentForm.vue?vue&type=style&index=0&id=9a140c56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a140c56"]])

export default __exports__